export enum OnboardingTemplatesTableFields {
  id = 'id',
  name = 'name',
  stepCount = 'stepCount',
  steps = 'steps',
  actions = 'actions',
}
